import { HealthCheck } from './healthCheck.model';

export const healthCheckMock = new HealthCheck(
  {
    crewMemberId: '10000',
    docType: 'HEALTH_SURVEY',
    lastUpdateSource: 'Web',
    shipCode: 'AL',
    signonDate: '20210611',
    lastUpdated: '20210611T0126',
    responses: [
      {
        Vomiting: 'NO',
        Fever: 'YES',
        invalid: 'invalid answer',
      },
    ],
  },
  [
    {
      key: 'vomiting',
      value: 'Vomiting',
    },
    {
      key: 'diarrhea',
      value: 'Diarrhea',
    },
    {
      key: 'bloodystool',
      value: 'Bloody Stools',
    },
  ],
  [
    {
      key: 'diarrheacontact',
      value: 'In the past three (3) days, have you been in contact with someone who experience diarrhea or vomiting?',
    },
    {
      key: 'influenzacontact',
      value:
        'In the past seven (7) days, have you been diagnosed OR in contact with someone who has been diagnosed with Influenza (Flu)?',
    },
  ],
);
